import { useState } from 'react';
import { Container, Row, Col, Form, Button, Modal } from 'react-bootstrap';
import { motion } from 'framer-motion';
import   './index.css'
import { toast } from 'react-toastify';
import AccountsService from '../../Services/AccountsService';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../Utils/Auth';
const PasswordModal = ({ show, onHide, isLoading }) => {
    const [passwordData, setPasswordData] = useState({
        currentPassword: '',
        newPassword: '',
        confirmPassword: ''
    });
    const [showPasswords, setShowPasswords] = useState({
        current: false,
        new: false,
        confirm: false
    });
    const navigate = useNavigate()
    const auth = useAuth();

    const handlePasswordChange = (e) => {
        const { name, value } = e.target;
        setPasswordData({ ...passwordData, [name]: value });
    };

    const togglePasswordVisibility = (field) => {
        setShowPasswords({
            ...showPasswords,
            [field]: !showPasswords[field]
        });
    };

    // const handleSubmit = (e) => {
    //     e.preventDefault();
    //     // Password change logic here
    //     onHide();
    // };


      const handleSubmit = (e) => {
        e.preventDefault();
        if (!passwordData.newPassword || !passwordData.confirmPassword) {
          toast.info("Please Fill In All Password Fields.");
          return;
        }
        if (passwordData.newPassword === passwordData.confirmPassword) {
          const data = {
            userName: auth.user.userName,
           
            password: passwordData.confirmPassword,
          };
          AccountsService.ResetPassword(data, auth.user)
            .then((res) => {
              toast.success(res?.data?.message);
              onHide();
              navigate("/");
            })
            .catch((err) => {
              toast.error(err.response.data?.errMessage);
              return;
            });
        } else {
          toast.info("Password Should be Same");
        }
      };

    return (
        <Modal
            show={show}
            onHide={onHide}
            centered
            className="password-modal"
            backdrop="static"
        >
            <motion.div
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                className="modal-content"
            >
                <Modal.Header closeButton className="modal-header">
                    <Modal.Title className="modal-title">Change Password</Modal.Title>
                </Modal.Header>
                <Form onSubmit={handleSubmit}>
                    <Modal.Body className="modal-body">
                  

                        <Form.Group className="mb-4">
                            <Form.Label className="input-label">New Password</Form.Label>
                            <div className="input-group-password">
                                <Form.Control
                                    type={showPasswords.new ? "text" : "password"}
                                    name="newPassword"
                                    value={passwordData.newPassword}
                                    onChange={handlePasswordChange}
                                    required
                                    className="form-input"
                                />
                                <button
                                    type="button"
                                    className="password-toggle"
                                    onClick={() => togglePasswordVisibility('new')}
                                >
                                    <i className={`fas ${showPasswords.new ? "fa-eye-slash" : "fa-eye"}`}></i>
                                </button>
                            </div>
                        </Form.Group>

                        <Form.Group className="mb-4">
                            <Form.Label className="input-label">Confirm New Password</Form.Label>
                            <div className="input-group-password">
                                <Form.Control
                                    type={showPasswords.confirm ? "text" : "password"}
                                    name="confirmPassword"
                                    value={passwordData.confirmPassword}
                                    onChange={handlePasswordChange}
                                    required
                                    className="form-input"
                                />
                                <button
                                    type="button"
                                    className="password-toggle"
                                    onClick={() => togglePasswordVisibility('confirm')}
                                >
                                    <i className={`fas ${showPasswords.confirm ? "fa-eye-slash" : "fa-eye"}`}></i>
                                </button>
                            </div>
                        </Form.Group>
                    </Modal.Body>
                    <Modal.Footer className="modal-footer">
                        <motion.div
                            whileHover={{ scale: 1.02 }}
                            whileTap={{ scale: 0.98 }}
                        >
                            <Button
                                variant="secondary"
                                onClick={onHide}
                                className="modal-button cancel-btn"
                            >
                                Cancel
                            </Button>
                        </motion.div>
                        <motion.div
                            whileHover={{ scale: 1.02 }}
                            whileTap={{ scale: 0.98 }}
                        >
                            <Button
                                variant="primary"
                                type="submit"
                                className="modal-button submit-btn"
                                disabled={isLoading}
                            >
                                {isLoading ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                        Updating...
                                    </>
                                ) : 'Update Password'}
                            </Button>
                        </motion.div>
                    </Modal.Footer>
                </Form>
            </motion.div>
        </Modal>
    );
};

export default PasswordModal;